import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-stone-900 flex items-center justify-center p-4">
      <Seo title="Admin Login" noindex />
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="font-serif-display text-3xl font-black text-white">The PM Test</div>
          <div className="font-mono-pm text-[10px] tracking-[0.25em] uppercase text-[#CCFF00] mt-1">Admin Access</div>
        </div>
        <form onSubmit={submit} data-testid="login-form" className="bg-white border-2 border-stone-900 p-8 hard-shadow">
          <label className="font-mono-pm text-[11px] tracking-widest uppercase text-stone-600 block mb-2">Email</label>
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="w-full border border-stone-900 px-4 py-3 mb-5 focus:outline-none focus:hard-shadow transition-shadow" />
          <label className="font-mono-pm text-[11px] tracking-widest uppercase text-stone-600 block mb-2">Password</label>
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="w-full border border-stone-900 px-4 py-3 mb-6 focus:outline-none focus:hard-shadow transition-shadow" />
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-stone-900 text-white py-4 font-mono-pm font-bold text-sm tracking-widest uppercase hover:bg-[#991B1B] transition-colors disabled:opacity-50">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
